<div class="container-tab uploaded-file-tab">
  <form #form="ngForm" class="form-container pt-4">
    <rss-source [playlist]="playlist" [playlistItem]="playlistItem"></rss-source>
  </form>

  <mat-toolbar class="tab-footer unset">
    @if (!playlistItem.Id) {
      <mat-checkbox [disableRipple]="true" [(ngModel)]="addAnother" name="addAnother"
        class="light" matTooltip="Add one more item to the Playlist">Add Another</mat-checkbox>
    }
    <button type="button" mat-raised-button (click)="cancel.emit()" mat-flat-button matTooltip="Cancel">Cancel</button>
    <button
      type="submit"
      (click)="onSubmit()"
      [disabled]="form.invalid || (!playlistItem.RssConfigs?.Url && !playlistItem.RssConfigs?.FileId)"
      mat-flat-button matTooltip="Save">
      Save
    </button>
  </mat-toolbar>
</div>
